import db from "@/plugins/dexie";
import apivarejoweb from '@/services/api-varejoweb';
import moment from "moment-timezone";
import store from "@/store";
import $_enviaPrestacaoServicoItem from "./enviaCadastroItem"; 
import $_enviaVeiculo from "./enviaVeiculo";
import { SetupEnvioLocal } from '@/utils/atualizalocal';
import { testarConexaoApi } from '@/utils/isonline';
import geraData, { converterDataApiParaLocal } from '@/utils/geradata';

const tabela = 'prestacaoservico';
const idnuvem = 'prsidnuvem';

export default async function $_enviaPrestacaoServico(idLocal = null) {

  const conectou = await testarConexaoApi();
  if (!conectou) {
    throw new Error('Sem conexão com a API');
  }

  const tokenString = sessionStorage.getItem('auth:token');

  if (!tokenString || tokenString === 'undefined' || tokenString === 'null') {
    throw new Error('Token de autenticação não encontrado');
  }
  const token = JSON.parse(tokenString);

  if (idLocal && typeof $_enviaVeiculo === 'function') {
    try {
      await $_enviaVeiculo(idLocal);
    } catch (err) {
      console.error("Erro ao enviar veículo antes da prestação de serviço:", err);
    }
  }

  let registros = await db[tabela].toArray();

  if (idLocal) {
    registros = registros.filter(i => i.id === idLocal);
  } else {
    registros = registros.filter(i => !i.prsdatatransmissao || !i.prsidprestacaoservico);
  }

  const formataData = (data, formato) => {
    if (!data || data === 'null' || data === '') return null;
    const m = moment(data);
    return m.isValid() ? m.format(formato) : null;
  };

  const safeInt = (val) => {
    if (val === null || val === undefined || val === '' || val === 'null') return null;
    const num = Number(val);
    if (isNaN(num) || num > 2147483647 || num < -2147483648) return null;
    return num;
  };

  const promises = registros.map(async (item) => {
    let idEmpresaPayload = safeInt(item.prsidempresa);
    if (!idEmpresaPayload) {
      try {
        const empLocal = await db.empresa.toCollection().first();
        if (empLocal) {
          idEmpresaPayload = safeInt(empLocal.idempresa || empLocal.ID_Eempidempresampresa || empLocal.empidnuvem);
        }
      } catch (e) {
        console.warn("Erro ao buscar empresa no Dexie em enviaCadastro:", e);
      }
      if (!idEmpresaPayload) {
        const sessEmp = sessionStorage.getItem('empidempresa');
        if (sessEmp) idEmpresaPayload = safeInt(sessEmp);
      }
    }

    const payload = {
      IDCLIENTE: safeInt(item.prsidcliente),
      VALOR: 0,
      tipo: safeInt(item.prstipo) || 1,
      IDEMPRESA: idEmpresaPayload,
      idFornecedorIndicacao: safeInt(item.prsidfornecedor),
      IdFornecedorIndicacao: safeInt(item.prsidfornecedor),
      idVendedorServico: safeInt(item.prsidvendedor),
      IDRECEBIDO: safeInt(item.prsrecebidopor),
      IDTECNICOVERIFICACAO: safeInt(item.prsidtecnicoverificacao),
      IdTecnicoVerificacao: safeInt(item.prsidtecnicoverificacao),
      DATACADASTRO: formataData(item.prsdatainclusao, 'YYYY-MM-DD'),
      HORACADASTRO: formataData(item.prsdatainclusao, 'HH:mm'),
      DEFEITO: item.prsdefeito ? String(item.prsdefeito).trim().slice(0, 50) : null,
      OBSERVACAOEQUIPAMENTO: item.prsobservacao ? String(item.prsobservacao).trim().slice(0, 50) : null,
      NUMEROSERIEEQUIPAMENTO: (item.prsnumeroserieequipamento || item.numSerie) ? String(item.prsnumeroserieequipamento || item.numSerie).trim().slice(0, 15) : null,
      DESCRICAOEQUIPAMENTO: item.prsdescricaoequipamento ? String(item.prsdescricaoequipamento).trim() : null,
      MARCAEQUIPAMENTO: item.prsmarcaequipamento ? String(item.prsmarcaequipamento).trim() : null,
      IDENTIFICACAOIDSEQUIPAMENTO: item.prsidentificacaoidsequipamento ? String(item.prsidentificacaoidsequipamento).trim() : null,
      DadoComplementar: item.prsdadocomplementar ? String(item.prsdadocomplementar).trim() : null,
      Livre1: item.prslivre1 ? String(item.prslivre1).trim() : null,
      Livre2: item.prslivre2 ? String(item.prslivre2).trim() : null,
      Livre3: item.prslivre3 ? String(item.prslivre3).trim() : null,
      IDVEICULO: safeInt(item.prsidveiculo),
      IdMarcaVeiculo: safeInt(item.prsidmarcaveiculo),
      KM: safeInt(item.prskm),
      Motor: item.prsmotor ? String(item.prsmotor).trim().slice(0, 10) : null,
      Ano: safeInt(item.prsanoveiculo),
      AnoModelo: safeInt(item.prsanomodeloveiculo),
      Combustivel: item.prscombustivel ? String(item.prscombustivel).trim().slice(0, 1).toUpperCase() : null,
      NroChassi: item.prsnumerochassi ? String(item.prsnumerochassi).trim().slice(0, 17) : null,
      ORSIdUsuarioCadastro: safeInt(item.prsidusuario),
      ORSIdUsuarioAlteracao: safeInt(item.prsidvendedoralteracao),
      ORSDataInclusao: formataData(item.prsdatainclusao, 'YYYY-MM-DD HH:mm:ss'),
      ORSDataAlteracao: formataData(item.prsdataalteracao, 'YYYY-MM-DD HH:mm:ss'),
    };

    let res = null;
    try {
      if (item[idnuvem] && item[idnuvem] !== 'null') {
        res = await apivarejoweb.put(`/prestacaoservico/${item[idnuvem]}`, payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      } else {
        res = await apivarejoweb.post('/prestacaoservico', payload, {
          headers: { Authorization: `Bearer ${token.token}` }
        });
      }
    } catch (err) {
      console.error('Erro na requisição (POST/PUT):', err.response?.data || err);
      throw err;
    }

    if (res) {
      const apiDataRaw = res.data?.ORSDataAlteracao || res.data?.DATACADASTRO || res.data?.ORSDataInclusao;
      const alteracao = apiDataRaw ? converterDataApiParaLocal(apiDataRaw) : (item.prsdataalteracao || geraData());
      const dataTransmissao = geraData();
      
      await db[tabela].update(item.id, {
        prsidnuvem: res.data.id ?? res.data.IDORDEMSERVICO ?? item[idnuvem],
        prsidprestacaoservico: res.data.IDORDEMSERVICO ?? res.data.id ?? item[idnuvem],
        prsdataalteracao: alteracao,
        prsdatatransmissao: dataTransmissao, 
      });

      store.dispatch('cache/atualizaData', { data: alteracao, tabela: `${tabela}` });
      await store.dispatch('cache/reloadCache', 'prestacaoservico');
      
      let itensOS = [];
      try {
        itensOS = await db.prestacaoservicoitem.filter(ci => 
          (item.prslinkpedidoitem && ci.prilinkpedidoitem === item.prslinkpedidoitem) ||
          (item.id && ci.idprestacaoservico === item.id) ||
          (item[idnuvem] && ci.priidprestacaoserviconuvem && String(ci.priidprestacaoserviconuvem) === String(item[idnuvem]))
        ).toArray();
      } catch (e) {
        console.error("Erro ao buscar prestacaoservicoitem em enviaCadastro:", e);
      }

      const itensUpdate = itensOS.flatMap((ci) => {
        if (ci.priidprestacaoserviconuvem) return []; 
        return [{
          key: ci.id,
          changes: {
            priidprestacaoserviconuvem: res.data.id ?? item[idnuvem],
          }
        }]
      });
      
      if (itensUpdate.length > 0) {
        await db.prestacaoservicoitem.bulkUpdate(itensUpdate);
      }
    }
    return res;
  });

  const resultados = await Promise.all(promises);
  const teveSucesso = resultados.some(res => res && (res.status === 200 || res.status === 201 || res.data));

  if (!teveSucesso) {
    throw new Error('Falha ao transmitir Ordem de Serviço na API');
  }

  if (typeof $_enviaPrestacaoServicoItem === 'function') {
      await $_enviaPrestacaoServicoItem(idLocal);
  }

  try {
    await SetupEnvioLocal({ silent: true });
  } catch (err) {
    console.warn("Aviso: Falha ao executar SetupEnvioLocal pós-envio de OS:", err);
  }

  return resultados[0] || null;
}